module.exports = __webpack_public_path__ + "img/top1.bb6fcec9.png";